var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getOrganisationArchivedAssets from '../../requests/asset/getOrganisationArchivedAssets';
/**
 *
 */
var GetOrganisationArchivedAssetsCommand = /** @class */ (function (_super) {
    __extends(GetOrganisationArchivedAssetsCommand, _super);
    function GetOrganisationArchivedAssetsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param archivedAssetCollection ArchivedAssetCollection
     * @return {Promise<T | never>}
     */
    GetOrganisationArchivedAssetsCommand.prototype.execute = function (organisation, archivedAssetCollection) {
        this.archivedAssetCollection = archivedAssetCollection;
        return getOrganisationArchivedAssets(organisation.id, false).then(this.then).catch(this.catch);
    };
    /**
     *
     * @param response
     */
    GetOrganisationArchivedAssetsCommand.prototype.then = function (response) {
        this.archivedAssetCollection.reset(false);
        this.archivedAssetCollection.addAll(response);
    };
    /**
     *
     * @param error
     */
    GetOrganisationArchivedAssetsCommand.prototype.catch = function (error) {
    };
    return GetOrganisationArchivedAssetsCommand;
}(Command));
export default GetOrganisationArchivedAssetsCommand;
